var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideocallblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.75 0C12.612 0 13.4386 0.319582 14.0481 0.888443C14.6576 1.4573 15 2.22884 15 3.03333V3.1948L18.864 1.03133C18.9778 0.967575 19.1077 0.933147 19.2404 0.931564C19.3731 0.929981 19.5039 0.9613 19.6194 1.02232C19.735 1.08335 19.831 1.17189 19.8979 1.2789C19.9648 1.38592 20 1.50758 20 1.63147V12.3667C20 12.4905 19.9648 12.6122 19.8979 12.7192C19.831 12.8262 19.735 12.9148 19.6194 12.9758C19.5039 13.0368 19.3731 13.0682 19.2404 13.0666C19.1077 13.065 18.9778 13.0306 18.864 12.9668L15 10.8033V10.9667C15 11.7712 14.6576 12.5427 14.0481 13.1116C13.4386 13.6804 12.612 14 11.75 14H3.25C2.38805 14 1.5614 13.6804 0.951903 13.1116C0.34241 12.5427 0 11.7712 0 10.9667V3.03333C0 2.22884 0.34241 1.4573 0.951903 0.888443C1.5614 0.319582 2.38805 0 3.25 0H11.75ZM11.75 1.4H3.25C2.78587 1.4 2.34075 1.57208 2.01256 1.87839C1.68437 2.1847 1.5 2.60015 1.5 3.03333V10.9667C1.5 11.8683 2.284 12.6 3.25 12.6H11.75C12.2141 12.6 12.6592 12.4279 12.9874 12.1216C13.3156 11.8153 13.5 11.3999 13.5 10.9667V3.03333C13.5 2.60015 13.3156 2.1847 12.9874 1.87839C12.6592 1.57208 12.2141 1.4 11.75 1.4ZM18.5 2.86813L15 4.82907V9.17L18.5 11.13V2.86813Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocallblack);
export default __webpack_public_path__ + "static/media/videocallblack.a8514c2a292f549eca243f3790a25af2.svg";
export { ForwardRef as ReactComponent };